import { useDispatch, useSelector } from 'react-redux';
import { navigateTo } from '../../redux/Slice/navigationSlice';
import { Button, LinkButton, WorkInProgressSVG } from 'common-ui-components';
import { selectConfig } from '../../redux/selectors';

const Promoter = () => {
  const dispatch = useDispatch();
  const {
    language: {
      promoter: { firstScreen: text },
    },
    configs: { maintenance },
  } = useSelector(selectConfig);

  const handleSubmit = () => {
    dispatch(navigateTo(maintenance ? 'CantRefferNewClientsError' : 'WelcomeForm'));
  };

  const handleSubmitCheck = (e) => {
    e.preventDefault();
    dispatch(navigateTo('CheckStatusService'));
  }

  return (
    <section className='section promoter'>
      <div className='home-background'></div>
      <div className='promoter-top'>
        <WorkInProgressSVG transparent style={{ width: '200px', height: '120px' }} />
      </div>
      <h2 className='promoter-title'>{text.title}</h2>
      <div className='promoter-content'>
        <p className='promoter-subtitle'>{text.subtitle}</p>
        <ul className='promoter-benefits'>
          {text.benefits.map((benefit) => (
            <li
              className='promoter-benefits-text'
              key={benefit.id}
              dangerouslySetInnerHTML={{ __html: benefit.text }}
            ></li>
          ))}
        </ul>
        <Button
          className='submit-button-error'
          onClick={handleSubmit}
          data-testid='promoter-start-button'
        >
          {text.button}
        </Button>
        <LinkButton
          className='promoter-check-button'
          onClick={handleSubmitCheck}
          data-testid='promoter-start-button-check'
        >
          {text.buttonCheck}
        </LinkButton>
      </div>
    </section>
  );
};

export default Promoter;
